import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import * as $ from 'jquery';
import { SucursalesListComponent } from './sucursales-list.component';
import { SucursalesService } from './sucursales.service';
import { ISucursal } from './sucursal';
import * as myGlobals from './../global';
import { Observable } from 'rxjs/Observable';
import { Negocio } from '../negocios/negocio';
import { NegociosService } from '../negocios/negocios.service';
import { Ciudad } from '../ciudades/ciudad';
import { CiudadesService } from '../ciudades/ciudades.service';
import {Router} from '@angular/router';
import {HttpClientSecured} from '../services/http-client-secured';

@Component({
  selector: 'pm-edit-sucursal',
  templateUrl: './edit-sucursal.component.html',
  styleUrls: ['./edit-sucursal.component.sass'],
  providers: [SucursalesService]
})
export class EditSucursalComponent implements OnInit, OnDestroy, AfterViewInit {
  sucursales: ISucursal[] = [];
  errorMessage = '';
  sucursal: ISucursal;
  businessSelected: number;

  businessList: Observable<Negocio[]> = this.businessService.allRecords();
  citiesList: Observable<Ciudad[]> = this.ciudadesService.allRecords();

  constructor(
    public service: SucursalesService,
    private parent: SucursalesListComponent,
    private businessService: NegociosService,
    private ciudadesService: CiudadesService,
    private router: Router,
    private http: HttpClientSecured
  ) {}

  ngOnInit() {
    console.log('EditSucursalComponent: OnInit: id: ', this.parent.editnumber);
    this.getSucursal(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=sucursales]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      name: $('input[name=name]').val(), // Adana Aguascalientes,
      nodeIdentifier: $('input[name=nodeIdentifier]').val(), // ,
      nodeKey: $('input[name=nodeKey]').val(), // ADAN,
      affiliationNumber1: $('input[name=affiliationNumber1]').val(), // 7752377,
      affiliationNumber2: $('input[name=affiliationNumber2]').val(), // 9353248330,
      status: 1, // ,
      street: $('input[name=street]').val(), // Av. Tecnologico,
      neighborhood: $('input[name=neighborhood]').val(), // Ejido Ojo Caliente,
      postalCode: $('input[name=postalCode]').val(), // 20198,
      internalNumber: $('input[name=internalNumber]').val(), // ,
      externalNumber: $('input[name=externalNumber]').val(), // S/N,
      phone: $('input[name=phone]').val(), // (449) 970-0737,
      cityId: $('#cityId option:selected').val(), // 111,
      // cityName: ''; // Aguascalientes,
      businessId: $('#businessId option:selected').val() // 116,
      // businessName: ''; // GP Business
    };
    console.log(formData);

    const routerRef = this.router;

    this.http.put<void>(myGlobals.baseApi + '/webadmin/v1/merchant/' + elemento.parent.editnumber , formData ).subscribe(
      res => {
        console.log('AddPromocionComponent: addPromocion: res: ', res);
        this.parent.showSucursales = true;
        this.parent.showAddSucursal = false;
        this.parent.showEditSucursal = false;
      },
      err => console.log('AddPromocionComponent: addPromocion: err: ', err)
    );

    /*
    $.ajax({
      url: myGlobals.server + '/webadmin/v1/merchant/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function(response) {
      console.log('delete sucess!!');
      routerRef.navigate(['/sucursales']);
    });*/
    return false;
  }

  getSucursal(id: number): any {
    this.service.getSucursal(id).subscribe(
      sucursal => {
        this.sucursal = sucursal;
        this.businessSelected = sucursal.id;
        console.log('EditSucursalComponent: getSucursal: businessSelected: [', this.businessSelected, ']');
      },
      error => (this.errorMessage = error as any)
    );
  }

  cancelSucursal(): void {
    this.parent.showSucursales = true;
    this.parent.showAddSucursal = false;
    this.parent.showEditSucursal = false;
  }

  ngOnDestroy() {
    $('a[rel=sucursales]').removeClass('selected');
  }
}
